import { useEffect, useState } from "react"
import { TOKEN_KEY, logout } from "../../services/auth"
import AdminHeader from "../../components/admin/AdminHeader"
import AdminApps from "../../components/admin/AdminApps"
import ImvReg from "../../components/admin/apps/ImvReg.1"
import ImvsForEdit from "../../components/admin/apps/ImvsForEdit"
import Locations from "../../components/admin/apps/Locations"

export default function AdminHome({ setIsAuthenticated }) {
    const [token, setToken] = useState(null)
    const [isHome, setIsHome] = useState(true)
    const [app, setApp] = useState('default')

    useEffect(() => {
        setToken(localStorage.getItem(TOKEN_KEY))
    }, [])

    const logout = () => {
        setIsAuthenticated(false)
    }

    const appComponents = {
        default: <AdminApps setApp={setApp} isHome={setIsHome} />,
        ImvReg: <ImvReg setApp={setApp} isHome={setIsHome} />,
        Imvs: <ImvsForEdit setApp={setApp} isHome={setIsHome} />,
        Locations: <Locations setApp={setApp} isHome={setIsHome} />
    }

    return <section className="bg-[#0a101c] min-h-screen">
        <AdminHeader setApp={setApp} isHome={isHome} setIsHome={setIsHome} logout={logout} />
        <h1 className="text-center my-14 text-4xl font-thin"> FAI Imoveis | Administração </h1>

        <div className="border-t xl:w-2/3 xl:mx-auto border-blue-500"></div>

        <section className="justify-center">
            {appComponents[app]}
        </section>
    </section>
}